module.exports = __webpack_public_path__ + "static/media/icon-close.d57cc9d5.svg";